import styled from "styled-components";


export const Container = styled.section`
  margin-top: 15rem;
  
  h2{
    text-align: center;
    font-size: 4rem;
    margin-bottom: 3rem;
  }
  .projects{
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: auto;
    gap: 2rem;
    padding: 1rem;
    overflow: hidden;

    .project{
      padding: 2.5rem;
      background-color: var(--terminal-bg);
      border: 1px solid var(--terminal-border);
      border-radius: 6px;
      transition: 0.25s;
      display: flex;
      flex-direction: column;
      height: 100%;
      color: #FFF;
      font-family: 'Fira Code', monospace;
      position: relative;
      
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 4px;
        background: var(--green);
        border-radius: 6px 6px 0 0;
        opacity: 0.3;
      }

      &:hover{
        transform: translateY(-5px);
        border-color: var(--green);
        &::before {
          opacity: 1;
        }
      }

      header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: var(--green);
        margin-bottom: 2rem;
        .project-links{
          display: flex;
          align-items: center;
          gap: 1.5rem;
        }
        .api-route {
          font-size: 1.2rem;
          font-weight: 600;
          .method {
            color: var(--green);
            margin-right: 0.5rem;
          }
        }
        a > img {
          width: 2.4rem;
          filter: brightness(0) invert(1);
          opacity: 0.7;
          transition: 0.2s;
          &:hover {
            opacity: 1;
            filter: none;
          }
        }
      }
      
      .code-body {
        font-size: 1.3rem;
        line-height: 1.8;
        
        .key {
          color: var(--blue);
        }
        
        .value {
          color: #ce9178; // VS Code string color
        }
        
        .bracket {
          color: #ffd700;
        }

        .number {
          color: #b5cea8;
        }
      }

      footer{
        margin-top: 2rem;
        padding-top: 2rem;
        border-top: 1px solid var(--terminal-border);
        .tech-list{
          display: flex;
          flex-wrap: wrap;
          align-items: center;
          gap: 1rem;
          font-size: 1.2rem;
          
          li {
            background: var(--terminal-header);
            padding: 0.4rem 1rem;
            border-radius: 4px;
            border: 1px solid var(--terminal-border);
            color: var(--green);
          }
        }
      }

    }
  }

  @media (max-width: 960px){
    .projects{
      grid-template-columns: 1fr 1fr;
    }
  }

  @media (max-width: 740px){
    .projects{
      grid-template-columns: 1fr;
    }
  }
`